<template>
  <div class="hello">
    <header>
      <h1>Sweet定位-VIP自动续费协议</h1>
      <p>最近更新日期：2025年10月29日</p>
    </header>
    <section>
      <h2>重要提示</h2>
      <p>欢迎您使用“Sweet定位 VIP”自动续费服务（以下简称“自动续费服务”或 “本服务”）。为保障您的权益，请在使用本服务前详细阅读本协议所有内容，未成年人应在法定监护人陪同下阅读。当您在开通VIP时主动选择“连续包月”或“连续包季”或“连续包年”的选项时，则表示您已与重庆盛纳科技有限公司（以下简称“公司”）达成协议，并自愿接受本协议的所有内容。</p>
      <h2>一、协议条款的接受与修订</h2>
      <p>1.1 本协议为《Sweet定位-VIP服务协议》《Sweet定位-用户协议》及本公司已发布或将来可能发布/更新的各类规则的组成部分，与上述协议正文具有同等法律效力。本协议未约定事项，以《Sweet定位-用户协议》《Sweet定位-VIP服务协议》为准；本协议与其他协议及规则存在冲突的，以本协议为准。公司不时发布的关于VIP服务协议的修订是《Sweet定位-用户协议》的一部分，公示后生效。</p>
      <p>1.2 请您理解并同意，前述协议内容与规则是使用本服务的先决条件。若您不同意本协议或任一条款，请不要进行后续操作；若您继续使用本服务，即视为同意遵守前述协议内容与规则。</p>
      <h2>二、服务说明</h2>
      <p>2.1 自动续费服务分为连续包月、连续包季和连续包年三种类型，对应的订阅周期费用分别为包月费用、包季费用和包年费用。若您开通本自动续费服务，且在订阅期内未主动明确取消本自动续费服务，则授权公司通过苹果App Store支付渠道，在包月/包季/包年（以您开通的自动续费类型为准）服务有效期即将过期时，从您的苹果账户中扣取下一个订阅周期费用。</p>
      <p>2.2 自动续费是指公司通过苹果App Store支付渠道收取下一个订阅周期费用，记入支付记录并延长付费服务有效期的扣费方式。您需保证苹果账户可正常扣款（如账户余额充足、未关闭支付权限等），若因账户异常导致的续费失败，相关责任（包括但不限于权益终止、无法参加相关的活动等）由您自行承担。扣费周期及规则严格遵循苹果App Store订阅管理政策，以实际扣费时间为准。</p>
      <h2>三、服务规则</h2>
      <p>3.1 若您需要查询自动续费收费的具体情况，可通过苹果手机“设置”->“个人账户”->“订阅”页面查看相关订阅状态及扣费记录。</p>
      <p>3.2 若扣费过程出现差错，公司将协助您联系苹果App Store支付渠道查明原因，相关责任按苹果支付规则及双方过错程度划分。因苹果支付系统故障导致的问题，由公司协调苹果方处理；因您账户设置异常导致的问题，责任由您自行承担。</p>
      <p>3.3 在您选择本服务后，除非通过苹果订阅管理页面终止服务，否则对自动扣款的委托持续有效。通过苹果账户产生的费用，公司不以任何方式退还。</p>
      <h2>四、服务退订</h2>
      <p>4.1 在续费服务到期日期前，苹果App Store将按其规则发送订阅续期提醒（包括但不限于邮件、推送通知）。</p>
      <p>4.2 解约流程：您需通过苹果手机的设置进行操作，点击个人账户头像->“订阅”-> 选择 “Sweet定位 VIP订阅”-> 点击“取消订阅”，完成操作后即终止自动续费服务。</p>
      <p>4.3 您需在当前VIP周期到期前至少 24 小时完成取消订阅操作。若未在到期前取消，苹果系统将自动扣取下一周期费用，扣费成功后不予退款，服务周期自动延长。</p>
      <h2>五、补充说明</h2>
      <p>5.1 公司可根据运营政策主动停止提供自动续费服务，届时您选择的连续订阅VIP服务期限自该服务周期届满之日起终止。</p>
      <p>5.2 如有疑问，请通过邮件<b>sweet_9966@126.com</b>与我们进行沟通。</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px
}
.hello{
  margin:20px;
}
section{
  padding-bottom:20px;
}
h1 {
  font-size: 18px;
  margin: 10px 0;
}

h2 {
  margin: 10px 0;
  font-size: 14px
}


li {
  margin: 10px 0;
  list-style: none;
}


p {
  margin: 10px 0;
}

.tab {
  table-layout: fixed;
  text-align: left;
  width: 100%;
  border-collapse: collapse;
}

.tab tr {
  width: 100%;
}

.tab th {
  padding: 0 4px;
}

.tab td {
  width: 25%;
  padding: 0 4px;
  word-break: break-all;
}

.link {
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue